import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import * as Styled from "./dashboard.style";
import { ApplicationSpeedBox } from "./boxes/application-speed/application-speed-box";
import { LiftingPerformanceBox } from "./boxes/lifting-performance-box";
import { AirConsumptionBox } from "./boxes/air-consumption-box";
import { GraphPanel } from "ui/components/panels/graphs";
export var DashboardPanel = function () {
    return (_jsx(Styled.DashboardPanel, { children: _jsxs(Styled.Content, { children: [_jsx(GraphPanel, {}), _jsx(AirConsumptionBox, {}), _jsx(ApplicationSpeedBox, {}), _jsx(LiftingPerformanceBox, {})] }) }));
};
